import { UserSchema } from '../../definitions/schemas';

export const emptyOptionValue = 'search-more-options';
export const emptyOptionMessage = 'Search for more options...';
export const emptyUserOption = (): UserSchema => ({
  id: emptyOptionValue,
  dealsCount: 0,
  email: '',
  firstName: emptyOptionMessage,
  fullName: emptyOptionMessage,
  ownedRoomsCount: 0,
  roleName: '',
  roomsCount: 0,
  username: emptyOptionMessage,
});
